<template>
  <div style="">

    <el-tag style="margin: 25px;">
      说明：电子证只能查到2023年7月后考试合格数据。
    </el-tag>

    <div style="display: flex; flex-direction: column; justify-content: center;align-items: center">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" style="width:300px">
        <el-form-item label="姓名" prop="name" required>
          <el-input type="text" v-model="ruleForm.name" placeholder="请输入姓名"/>
        </el-form-item>

        <el-form-item label="身份证号" prop="sfzNumber" required>
          <el-input type="text" v-model="ruleForm.sfzNumber" placeholder="请输入身份证号"/>
        </el-form-item>

        <el-form-item label="证书类型" prop="certType" required>
          <el-select v-model="ruleForm.certType" placeholder="请选择类型">
            <el-option
                v-for="item in items"
                :key="item.value"
                :label="item.text"
                :value="item.value">
            </el-option>
          </el-select>

        </el-form-item>

        <el-form-item>
          <el-button type="success" style="margin-top: 60px; width: 200px; background-color: darkcyan"
                     @click="submitForm('ruleForm')">查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      items: [{value: '31,33', text: '主要负责人'},
        {value: '32,34', text: '安全生产管理人员'}],

      ruleForm: {
        // sfzNumber: "123456789",
        // certType: 1,
        // name: "张三",

        sfzNumber: null,
        certType: null,
        name: null,

      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        sfzNumber: [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
        ],
        certType: [
          {required: true, message: '请选择证件类型', trigger: 'change'}
        ],
      },


    }
  },

  mounted() {
    // this.getCertType()
  },
  methods: {
    onchange(e) {
      const value = e.detail.value
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },


    submit() {

      this.$axios.get(window.SITE_CONFIG['baseUrl'] + `/custom/genCert/queryCert2`, {

        params: {
          "idNumber": this.ruleForm.sfzNumber,
          "certType": this.ruleForm.certType,
          "name": this.ruleForm.name,
        }
      }).then(res => {
        console.log(res, 99990)
        if (res.data.code == 0) {
          this.$router.push(
              {
                name: 'certImage',
                params: {
                  imageUrl: res.data.data,
                  canDownload: res.data.canDownload,
                  userInfo: res.data.userInfo,
                }
              }
          )

        } else {
          this.$message.error(res.data.msg)
        }
        console.log(res)
      }).catch(error =>
          //请求失败，触发catch中的函数 可省略
          console.log(error)
      )


    },


    getCertType() {

      this.$axios.post(window.SITE_CONFIG['baseUrl'] + `/custom/genCert/queryClassList`, {}).then(res => {
        console.log(res, 99990)
        if (res.data.code == 0) {
          this.items = res.data.data

          this.items.forEach(item => {
            item.text = item.zsxmmc
            item.value = item.glpxxm

          })

        } else {
          this.$message.error(res.data.msg)
        }
        console.log(res)
      }).catch(error =>
          //请求失败，触发catch中的函数 可省略
          console.log(error)
      )


    },
  }
}
</script>

<style>
.container {
  padding: 20px;
  font-size: 14px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/fsindex.vue